module.exports = __webpack_public_path__ + "static/media/fort-collins-mobile.1ef26022.webp";